import Vue from 'vue';
import _ from 'lodash';
import api from '../../lib/api';

export const FETCH_PROMPTS = 'FETCH_PROMPTS';
export const FETCH_PROMPT = 'FETCH_PROMPT';
export const CREATE_PROMPT = 'CREATE_PROMPT';
export const UPDATE_PROMPT = 'UPDATE_PROMPT';
export const DELETE_PROMPT = 'DELETE_PROMPT';

const PROMPTS_LIST_LOADING_CHANGE = 'PROMPTS_LIST_LOADING_CHANGE';
const PROMPTS_LIST_CHANGE = 'PROMPTS_LIST_CHANGE';
const PROMPT_CHANGE = 'PROMPT_CHANGE';
const PROMPT_LOADING_CHANGE = 'PROMPT_LOADING_CHANGE';
const PROMPT_ERRORS_CHANGE = 'PROMPT_ERRORS_CHANGE';
const PROMPT_SAVING_CHANGE = 'PROMPT_SAVING_CHANGE';

const state = {
  prompts_list: [],
  prompts_list_loading: false,
  prompt: {},
  // Дефолтная структура промпта с пустыми значениями
  prompt_empty: {
    name: '',
    prompt: '',
    system_prompt: '',
    provider_type: '',
  },
  prompt_loading: false,
  prompt_saving: false,
  prompt_errors: {},
  // Кэш промптов с ключами по ID
  prompts_cache: {},
};

const actions = {
  /**
     * Загружает список промптов
     * @param {Object} options - Дополнительные опции (например, заголовки)
     */
  [FETCH_PROMPTS]({ commit, state }, { data = {}, options = {} }) {
    return api.list(
      'llm.prompts',
      '',
      data,
      state,
      commit,
      PROMPTS_LIST_LOADING_CHANGE,
      PROMPTS_LIST_CHANGE,
      null,
      options,
    );
  },

  /**
     * Загружает данные промпта по ID
     * @param {Number|String|Object} param - ID промпта или объект с параметрами
     * @param {Number|String} param.id - ID промпта
     * @param {Object} param.options - Дополнительные опции (например, заголовки)
     */
  [FETCH_PROMPT]({ commit, state }, param) {
    const id = param.id;
    const options = param.options || {};

    return api.load(
      'llm.prompt',
      id,
      state,
      commit,
      PROMPT_LOADING_CHANGE,
      PROMPT_CHANGE,
      PROMPT_ERRORS_CHANGE,
      options,
    );
  },

  /**
     * Создает новый промпт
     * @param {Object|String} param - Данные промпта или объект с параметрами
     * @param {Object} param.data - Данные промпта
     * @param {Object} param.options - Дополнительные опции (например, заголовки)
     */
  [CREATE_PROMPT]({ commit, state }, param) {
    // Поддерживаем два формата: простые данные или объект с параметрами
    const data = param.data;
    const options = param.options || {};

    return api.create(
      'llm.prompt.create',
      '',
      data,
      state,
      commit,
      PROMPT_SAVING_CHANGE,
      PROMPT_CHANGE,
      PROMPT_ERRORS_CHANGE,
      options,
    );
  },

  /**
     * Обновляет промпт
     * @param {Object} param - Параметры запроса
     * @param {Number|String} param.id - ID промпта
     * @param {Object} param.data - Данные промпта
     * @param {Object} param.options - Дополнительные опции (например, заголовки)
     */
  [UPDATE_PROMPT]({ commit, state }, param) {
    const id = param.id;
    const data = param.data;
    const options = param.options || {};

    return api.update(
      'llm.prompt.update',
      id,
      data,
      state,
      commit,
      PROMPT_SAVING_CHANGE,
      PROMPT_CHANGE,
      PROMPT_ERRORS_CHANGE,
      options,
    );
  },

  /**
     * Удаляет промпт
     * @param {Number|String|Object} param - ID промпта или объект с параметрами
     * @param {Number|String} param.id - ID промпта
     * @param {Object} param.options - Дополнительные опции (например, заголовки)
     */
  [DELETE_PROMPT]({ commit, state }, param) {
    const id = param.id;
    const options = param.options || {};

    commit(PROMPT_SAVING_CHANGE, true);
    return api.delete(
      'llm.prompt.delete',
      id,
      state,
      commit,
      PROMPT_CHANGE,
      options,
    ).finally(() => {
      commit(PROMPT_SAVING_CHANGE, false);
    });
  },
};

const mutations = {
  [PROMPTS_LIST_LOADING_CHANGE](state, data) {
    state.prompts_list_loading = data;
  },

  [PROMPTS_LIST_CHANGE](state, data) {
    if (data?.data) {
      state.prompts_list = data.data;
      data.data.forEach((prompt) => {
        if (prompt.id) {
          Vue.set(state.prompts_cache, prompt.id, prompt);
        }
      });
    } else {
      state.prompts_list = [];
    }
  },
  [PROMPT_CHANGE](state, data) {
    if (data) {
      state.prompt = data;
      if (data.id) {
        Vue.set(state.prompts_cache, data.id, data);
      }
    } else {
      state.prompt = _.cloneDeep(state.prompt_empty);
    }
  },

  [PROMPT_LOADING_CHANGE](state, data) {
    state.prompt_loading = data;
  },

  [PROMPT_SAVING_CHANGE](state, data) {
    state.prompt_saving = data;
  },

  [PROMPT_ERRORS_CHANGE](state, data) {
    state.prompt_errors = data || {};
  },
};

export default {
  state,
  actions,
  mutations,
};
